<script setup>
  import { ref, useTemplateRef, onMounted, watch } from 'vue';
  import { useGoogleMapsStore } from '@/stores/GoogleMapsStore';
  import useLegacyBridge from "@/composables/useLegacyBridge";
  import { useUpdateKey } from '@/composables/useUpdateKey';

  const model = defineModel();
  const viewType = defineModel('viewType');

  const props = defineProps({
    // Selected model id, owned by the parent's ModelSelector. The windbow
    // waits for a value before loading and reloads when it changes.
    modelId: {
      type: Number,
      default: null
    }
  });

  const googleMapsStore = useGoogleMapsStore();

  const { windbow } = useLegacyBridge();
  const updateKey = useUpdateKey()

  const contentContainer = useTemplateRef('contentContainer');
  const mapsLoaded = ref(false);

  function loadWindbow() {
    if (!mapsLoaded.value || props.modelId == null || model.value) return;

    const settings = {
      useExternalModelSelector: true,
      selectedModel: props.modelId,
      viewType: viewType.value,
      showViewTypeControl: false,
      showChartTimeframeControl: false,
    }

    model.value = windbow(contentContainer.value, settings);
  }

  function reloadWindbow() {
    contentContainer.value.innerHTML = "";
    model.value = null;
    loadWindbow()
  }

  onMounted(() => {
    googleMapsStore.loadMaps(() => {
      mapsLoaded.value = true;
      loadWindbow();
    });
  })

  watch(() => props.modelId, (modelId) => {
    if (modelId == null) return;

    if (!model.value) {
      loadWindbow();
      return;
    }

    model.value.setModel(modelId);
  })

  watch(updateKey.key, reloadWindbow)
</script>

<template>
  <div
    class="jwx-data-container__content"
    style="width: 100%;"
    ref="contentContainer"
  ></div>
</template>
